import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import {JSONValue} from 'util/Types';

/** @package */
export function getMinMaxErrorMessage(
  jsonValue: JSONValue,
  configShape: GetPipelineConfigSpecType<'integer'>
): string | null {
  if (jsonValue == null) {
    return null;
  } else if (typeof jsonValue === 'string' && !Number.isInteger(parseFloat(jsonValue))) {
    return 'Value must be a valid integer';
  }

  const value = Number(jsonValue);
  const min = configShape.minValue;
  const max = configShape.maxValue;

  if (min != null && max != null && (value < min || value > max)) {
    return `Value must be between ${min} and ${max}`;
  } else if (max != null && value > max) {
    return `Value must be less than ${max}`;
  } else if (min != null && value < min) {
    return `Value must be greater than ${min}`;
  }

  return null;
}
